import { Label, InputText, AlertError, Text } from '@ohgoodlord/design-system'
import { useFormContext, Controller } from 'react-hook-form'
import { css } from '@emotion/react'
import { FormValues } from '..'
import { Rules } from '../validation'

type TextFormValues = Omit<FormValues, 'mobileMeta' | 'nationality' | 'dob' | 'mobile'>

export const InputTextFormField = <T extends keyof TextFormValues>({
  fieldName,
  rules,
  label,
}: {
  label: string
  fieldName: T
  rules?: Rules<T>
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 5px;
      `}
    >
      <Label htmlFor={fieldName}>{label}</Label>
      <Controller
        name={fieldName}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <InputText
            {...field}
            aria-required={!!rules?.required}
            isInvalid={!!fieldState.error?.message}
            aria-invalid={!!fieldState.error?.message}
            aria-describedby={fieldState.error ? `${fieldName}-error` : undefined}
            name={fieldName}
            id={fieldName}
          />
        )}
      />
      {errors[fieldName] && (
        <div id={`${fieldName}-error`}>
          <AlertError>
            <Text>{errors[fieldName]?.message}</Text>
          </AlertError>
        </div>
      )}
    </div>
  )
}
